import { fromJS } from "immutable";
import * as actionTypes from "./actionTypes";

const initialState = fromJS({
  investmentData: {
    isLoading: true,
    data: [],
    error: ""
  },
  grant_data: {
    isLoading: true,
    data: [],
    error: ""
  },
  contribution: {
    isLoading: true,
    data: [],
    error: ""
  },
  accountSummaryBalance_data: {
    isLoadingBot: true,
    data: [],
    error: "",
    botStatusText: "Coming Soon"
  },
  accountSummaryBalance_data_all: {
    data: [],
    error: "",
    botStatusText: "Coming Soon",
    fiveYearData: false,
    isLoadingBot: false
  },
  account_data: {
    isLoading: true,
    data: [],
    error: ""
  },
  otherTransaction_data: {
    isLoading: true,
    data: [],
    error: ""
  },
  selectedHeader: "",
  myAccount_data: {
    isLoading: true,
    data: [],
    error: ""
  }
});

export const accountSummary = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetchInvestmentDataType:
      return state.setIn(["investmentData", "isLoading"], true);
    case actionTypes.fetchInvestmentDataSuccessType:
      return state
        .setIn(["investmentData", "data"], action.payload)
        .setIn(["investmentData", "isLoading"], false);

    case actionTypes.fetchGrantsDataType:
      return state.setIn(["grant_data", "isLoading"], true);
    case actionTypes.fetchGrantsDataSuccessType:
      return state
        .setIn(["grant_data", "data"], action.payload)
        .setIn(["grant_data", "isLoading"], false);

    case actionTypes.fetchContributionDataType:
      return state.setIn(["contribution", "isLoading"], true);
    case actionTypes.fetchContributionDataSuccessType:
      return state
        .setIn(["contribution", "data"], action.payload)
        .setIn(["contribution", "isLoading"], false);

    case actionTypes.fetchAccountSummaryBalanceDataType:
      return state
        .setIn(["accountSummaryBalance_data", "isLoadingBot"], true)
        .setIn(
          ["accountSummaryBalance_data", "botStatusText"],
          "Searching for results in this date range"
        );

    case actionTypes.fetchAccountSummaryBalanceDataSuccessType:
      return state
        .setIn(["accountSummaryBalance_data_all", "data"], [])
        .setIn(["accountSummaryBalance_data", "data"], action.payload)
        .setIn(["accountSummaryBalance_data", "isLoadingBot"], false)
        .setIn(
          ["accountSummaryBalance_data", "botStatusText"],
          "No data available for this date range"
        );
    case actionTypes.fetchAllAccountSummaryDataType:
      return state
        .setIn(["accountSummaryBalance_data_all", "isLoadingBot"], true)
        .setIn(
          ["accountSummaryBalance_data", "botStatusText"],
          "Searching for results in this date range"
        );

    case actionTypes.fetchAllAccountSummaryDataSuccessType:
      return state
        .setIn(["accountSummaryBalance_data_all", "data"], action.payload)
        .setIn(["accountSummaryBalance_data_all", "isLoadingBot"], false)
        .setIn(["accountSummaryBalance_data_all", "fiveYearData"], true)
        .setIn(["accountSummaryBalance_data", "botStatusText"], "Coming Soon");

    case actionTypes.fetchAccountSummaryBot3YrType:
      return state.setIn(
        ["accountSummaryBalance_data", "botStatusText"],
        "Coming Soon"
      );
    case actionTypes.fetchAccountDataType:
      return state.setIn(["account_data", "isLoading"], true);
    case actionTypes.fetchAccountDataSuccessType:
      return state
        .setIn(["account_data", "data"], action.payload)
        .setIn(["account_data", "isLoading"], false);
    case  actionTypes.fetchOtherTransactionDataType:
      return state.setIn(["otherTransaction_data", "isLoading"], true);
    case actionTypes.fetchOtherTransactionDataSuccessType:
      return state
        .setIn(["otherTransaction_data", "data"], action.payload)
        .setIn(["otherTransaction_data", "isLoading"], false);
    case actionTypes.fetchMyAccountDataType:
      return state.setIn(["myAccount_data", "isLoading"], true);
    case actionTypes.fetchMyAccountDataSuccessType:
      return state
        .setIn(["myAccount_data", "data"], action.payload)
        .setIn(["myAccount_data", "isLoading"], false);
    default:
      return state;
  }
};

export default accountSummary;
